export abstract class Mask {
  lastDeletedChar: string;

  transform(text: any, key?: any): any {
    if (key !== 'Backspace') {
      return this.processText(text, key);
    } else {
      this.lastDeletedChar = text[text.length - 1];
    }
  }

  processText(text, key) {
    if (this.isDigit(key)) {
      text = this.applyMask(text);
    } else {
      text = this.cleanText(text);
    }
    return text;
  }

  cleanText(text) {
    if (isNaN(text[text.length - 1])) {
      return text.slice(0, -1);
    }
    return text;
  }

  isDigit(key) {
    return !isNaN(key);
  }

  applyMask(text) {
    text = this.rebuildMaskAfterBackspace(text);
    text = this.addEspecialCharToCorrectLengthText(text);
    return text;
  }

  abstract rebuildMaskAfterBackspace(text);
  abstract addEspecialCharToCorrectLengthText(text);
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/pipe/interface/mask.ts